import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDCareersSceneController {
    private readonly sidebarController: UISidebarController
    private readonly careersSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.careersSceneContainerDiv = document.getElementById('scene_discord_careers_container') as HTMLDivElement
    }

    hide() {
        this.careersSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.careersSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
